import { WhereClausePreview } from '@modules/common/components/WhereClausePreview';
import { isEmptyWhereClause } from '@modules/common/utils';
import { CompareByFiltersPreview } from '@modules/quantify/components/QuantifyQueryBuilder/QuantifyQueryBuilderPreview/CompareByFiltersPreview';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { Stack, Typography } from '@mui/material';

export const WhereClauseFilterPreview = () => {
  const whereClause = useQuantifyStore(({ query }) => query?.whereClause);
  const compareTo = useQuantifyStore(({ query }) => query.compareQuery);

  if (compareTo?.whereClause) {
    return <CompareByFiltersPreview />;
  }

  const isWhereClausePresent =
    !!whereClause && !isEmptyWhereClause(whereClause);

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle1">Filter by:</Typography>
      {isWhereClausePresent ? (
        <WhereClausePreview whereClause={whereClause} />
      ) : (
        <Typography variant="body2" color="text.secondary">
          No filters applied
        </Typography>
      )}
    </Stack>
  );
};
